import { LineGraphLegendOrderLastValue } from '../types';

export const lastValue = (): LineGraphLegendOrderLastValue => {
    return {
        type: 'lastValue',
    };
};
